import { translateTemplateText } from '@focuslee/shared-mini-app';
import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { Chip, Text } from '@telegram-apps/telegram-ui';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ListCategory } from "../../client/types";
import { getColor } from "../../helpers/color";
import { categoryCreatePath } from '../../navigation/paths';
import { CategoryIcon } from "./CategoryIcon";
import { CommonIcon } from "./CommonIcon";
import { CustomSelect } from "./CustomSelect";

export type StyledCategorySelectProps = {
  categoryId: string;
  setCategoryId: (categoryId: string) => void;
  categories: ListCategory[];
  renderSelected?: (category?: ListCategory) => React.ReactNode;
  renderSelectedBefore?: (category?: ListCategory) => React.ReactNode;
  disabled?: boolean;
}

export const CategorySelect = (props: StyledCategorySelectProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (props.categories.length === 0) {
    return (
      <Chip
        mode="outline"
        before={<CommonIcon icon="add" type="filled" color="var(--tg-theme-text-color)" size={20} />}
        onClick={() => navigate(categoryCreatePath)}
        style={{
          border: '1px solid color-mix(in srgb, var(--tg-theme-text-color) 12%, transparent)',
          backgroundColor: 'color-mix(in srgb, var(--tg-theme-section-bg-color) 90%, transparent)',
          backdropFilter: 'blur(16px) saturate(160%)',
          WebkitBackdropFilter: 'blur(16px) saturate(160%)',
          cursor: 'pointer'
        }}
      >
        <Text>Create a category</Text>
      </Chip>
    );
  }

  return (
    <CustomSelect
      selectedId={props.categoryId}
      setSelectedId={props.setCategoryId}
      options={props.categories}
      disabled={props.disabled}
      before={(c) => (
        <Box sx={{
            width: 20,
            height: 20,
            borderRadius: 1,
            background: getColor(c.iconColor),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <CategoryIcon
                icon={c.icon}
                iconColor={c.iconColor}
                customIcon={c.customIcon}
                type="filled"
                size={14}
                color="var(--tg-theme-text-color)"
            />
        </Box>
      )}
      text={(c) => translateTemplateText(t, c.templateId, 'name', c.name)}
      renderSelected={props.categories ? props.renderSelected : () => <CircularProgress size="20px" />}
      renderSelectedBefore={props.categories ? props.renderSelectedBefore : () => <></>}
    />
  );
}
